// Free of imports: the website reads it in the browser, where `schema.ts` would pull zod and the toolkit.

/** The notifications about a Hub: each carries where it leads (`path`) and the matching `action`. */
export const HUB_NOTIFICATION_TYPES = [
  'HUB_PLACEMENT_ADDED',
  'HUB_PLACEMENT_BLOCKED',
  'HUB_MANAGER_ADDED',
  'HUB_MANAGER_REMOVED',
  'HUB_ARCHIVED',
  'HUB_ADDRESS_CHANGED',
  'HUB_APPROVED',
  'HUB_DECLINED',
  'HUB_REVISION_DECIDED',
  'ADMIN_HUB_PENDING'
] as const;

export type HubNotificationType = (typeof HUB_NOTIFICATION_TYPES)[number];

/** The element id of a professional's row on a Hub's Managers' professionals page: a link to it lands there. */
export const hubProfessionalAnchor = (professionalId: string): string => `professional-${professionalId}`;

/** A path inside the website without its locale: one leading slash, never `//` (another host). */
export const LOCALE_LESS_PATH = /^\/(?!\/)/;

/**
 * Where a notification leads, a path without the locale, when its metadata names one: the
 * one reader of `path` for the email button, the SMS and push links and the in-app list.
 */
export function notificationPath(metadata: Record<string, unknown> | null | undefined): string | undefined {
  const path = metadata?.path;
  return typeof path === 'string' && LOCALE_LESS_PATH.test(path) ? path : undefined;
}
